import { IconButton } from '@components/iconButton/IconButton';
import { useIsOpen } from '@shared/hooks/useIsOpen';
import styles from './BlockOrUnblockReservationsButton.scss';
import {
  BlockReservationsModal,
  BlockReservationsSubmitData,
} from './BlockReservationsModal';
import { useBlockReservations } from './hooks/useBlockReservations';
import { UnblockReservationsModal } from './UnblockReservationsModal';

export const BlockOrUnblockReservationsButton = () => {
  const {
    canBlockReservations,
    canUnblockReservations,
    blockReservations,
    unblockReservations,
    reservationDate,
    closures,
  } = useBlockReservations();

  const {
    open: openBlockReservationsModal,
    close: closeBlockReservationsModal,
    isOpen: isBlockReservationsModalOpen,
  } = useIsOpen();
  const {
    open: openUnblockReservationsModal,
    close: closeUnblockReservationsModal,
    isOpen: isUnblockReservationsModal,
  } = useIsOpen();

  const onConfirmBlockReservations = async (
    data: BlockReservationsSubmitData,
  ) => {
    await blockReservations(data);
    closeBlockReservationsModal();
  };

  const onConfirmUnblockReservations = async () => {
    await unblockReservations();
    closeUnblockReservationsModal();
  };

  return (
    <>
      {canBlockReservations && (
        <>
          <IconButton
            ariaLabel="block reservations"
            iconName="blockedSign"
            onClick={openBlockReservationsModal}
            className={styles.button}
            iconClassName={styles.icon}
            tooltipContent="Block Reservations"
            dataTooltipId="block-reservations-tooltip"
          />
          <BlockReservationsModal
            closeModal={closeBlockReservationsModal}
            isOpen={isBlockReservationsModalOpen}
            onConfirm={onConfirmBlockReservations}
            reservationDate={reservationDate}
          />
        </>
      )}
      {canUnblockReservations && (
        <>
          <IconButton
            ariaLabel="unblock reservations"
            iconName="unblockedSign"
            onClick={openUnblockReservationsModal}
            className={styles.button}
            iconClassName={styles.icon}
            tooltipContent="Unblock Reservations"
            dataTooltipId="unblock-reservations-tooltip"
          />
          <UnblockReservationsModal
            closeModal={closeUnblockReservationsModal}
            isOpen={isUnblockReservationsModal}
            onConfirm={onConfirmUnblockReservations}
            reservationDate={reservationDate}
            closures={closures}
          />
        </>
      )}
    </>
  );
};
